module.exports = __webpack_public_path__ + "img/006.21300420.jpg";